import r from"../Scrollbar/Scrollbar.theme.js";const t=o=>({body:r(o)});export{t as default};
